import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { filter, startWith, switchMap, tap } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  AnnulationRedditionData,
  InfoRedditionEnCours,
} from '../dialog-reddition-annulation/dialog-reddition-annulation.interface';
import { Evenement } from '../evenements.interface';

@Injectable({
  providedIn: 'root',
})
export class RedditionAnnulationService {
  private httpClient = inject(HttpClient);
  /* Relu a chaque ouverture, meme sur le meme element (`equal: () => false`) ; les infos sont
     vides (`startWith(undefined)`) tant que la reponse n'est pas arrivee. */
  private evenement = signal<Evenement | undefined>(undefined, { equal: () => false });

  redditionAAnnuler = signal<AnnulationRedditionData | undefined>(undefined);
  redditionAnnulee = signal<boolean>(false);

  private creationReddition = toSignal(
    toObservable(this.redditionAAnnuler).pipe(
      filter(a => !!a),
      switchMap(a =>
        this.httpClient.post<InfoRedditionEnCours>(
          `${environment.backendUrl}redditions/reddition/${a.idReddition}/annuler`,
          {
            commentaire: a.commentaire,
          },
        ),
      ),
      tap(() => this.redditionAnnulee.set(true)),
    ),
  );

  setEvenement(evenement: Evenement) {
    this.evenement.set(evenement);
  }

  infosRedditionEnCours = toSignal(
    toObservable(this.evenement).pipe(
      filter(evt => !!evt),
      switchMap(evt =>
        this.httpClient
          .get<InfoRedditionEnCours>(`${environment.backendUrl}redditions/evenements/${evt!.id}/reddition-en-cours`)
          .pipe(startWith(undefined)),
      ),
    ),
  );
}
